<!-- 审核管理 -->
<template>
    <div class="container">
        <div class="form">
            <el-form ref="formRef" :inline="true" label-width="90px" :model="{}">
                <el-row>
                    <el-col :span="7">
                        <el-form-item label="审核状态" prop="checkStatus">
                            <el-select v-model="form.auditStatus" clearable placeholder="请选择审核状态">
                                <template v-for="item in auditStatusList">
                                    <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey" />
                                </template>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="审核结果" prop="checkResult">
                            <el-select v-model="form.auditResult" clearable placeholder="请选择审核结果">
                                <template v-for="item in auditResultList">
                                    <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey" />
                                </template>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="操作人" prop="doctorName">
                            <el-select v-model="operId" clearable placeholder="请选择操作人">
                                <template v-for="item in doctorList">
                                    <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey" />
                                </template>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <div class="buttons">
                            <el-button type="primary" @click="queryList">查询</el-button>
                            <el-button @click="reSet">重置</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="list">
            <el-tabs v-model="activeKey">
                <el-tab-pane label="食谱知识库" />
                <el-tab-pane label="权威指南" />
                <el-tab-pane label="过敏源/饮食禁忌管理" />
            </el-tabs>
            <el-button type="primary" :disabled="!multipleList.length" @click="toggleBatchPassDialog(true)"
                style="width: fit-content;">批量通过</el-button>
            <el-table :data="table" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" align="center" width="55" :selectable="isSelectAble" />
                <el-table-column prop="serialNumber" align="center" label="序号">
                </el-table-column>
                <el-table-column prop="auditStatus" align="center" label="审核状态">
                    <template #default="{ row }">
                        <span :style="row.auditStatus === '1' ? 'color: #3FBE19' : ''">{{ auditStatusMap[row.auditStatus] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="checkResult" align="center" label="审核结果">
                    <div slot-scope="scope" class="tipsContainer">
                        <el-image v-if="scope.row.auditResult === '1'" :src="tipsOne"
                            @click="openReasonDialog(scope.row.rejectReason)" />
                        <span>{{ auditResultMap[scope.row.auditResult] || '-' }}</span>
                    </div>
                </el-table-column>
                <el-table-column prop="doctorName" align="center" label="医生名称">
                </el-table-column>
                <el-table-column prop="createTime" align="center" label="创建时间">
                </el-table-column>
                <el-table-column prop="contentName" align="center" label="审核内容">
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作">
                    <template #default="{ row }">
                        <div class="links">
                            <el-link type="primary"
                                @click="toggleDialog(true, row.content, 'check', row.id, row.auditStatus)">查看详情</el-link>
                            <el-popconfirm v-if="row.auditStatus === '1'" title="确定通过当前信息审核吗？" icon="el-icon-info"
                                @confirm="confirmSubmit(row.id)">
                                <template #reference>
                                    <span class="reference-class" style="margin-left: 10px; margin-right: 10px;">
                                        <el-link type="primary">通过</el-link>
                                    </span>
                                </template>
                            </el-popconfirm>
                            <el-link v-if="row.auditStatus === '1'" @click="toggleRejectDialog(true, row.id)"
                                type="danger">驳回</el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <!-- 展示错误原因弹窗 -->
        <ShowReasonDialog :isOpen.sync="isShowDialog" :toggleReasonDialog="toggleReasonDialog" :reasonTxt="reasonTxt" />
        <!-- 展示食谱弹窗 -->
        <RecipeDialog v-if="isShowRecipeDialog" :closeDialog="toggleDialog" :operType="operType" :content="content"
            :rowId="rowId" @fetchTableList="fetchTableList">
            <div style="text-align: center;">
                <template v-if="auditStatus === '1'">
                    <el-button type="primary" @click="confirmSubmit()">通 过</el-button>
                    <el-button type="danger" @click="toggleRejectDialog(true, rowId)">驳 回</el-button>
                </template>
                <el-button v-else @click="toggleDialog()">确 定</el-button>
            </div>
        </RecipeDialog>
        <!-- 展示权威指南弹窗 -->
        <AuthoritativeGuideDialog v-if="isShowAuthoritativeGuideDialog" :closeDialog="toggleDialog" :operType="operType"
            :content="content" :rowId="rowId" @fetchTableList="fetchTableList">
            <div style="text-align: center;">
                <template v-if="auditStatus === '1'">
                    <el-button type="primary" @click="confirmSubmit()">通 过</el-button>
                    <el-button type="danger" @click="toggleRejectDialog(true, rowId)">驳 回</el-button>
                </template>
                <el-button v-else @click="toggleDialog()">确 定</el-button>
            </div>
        </AuthoritativeGuideDialog>
        <!-- 过敏源弹窗 -->
        <AvoidFoodDialog v-if="isShowAvoidFoodDialog" :closeDialog="toggleDialog" :operType="operType"
            :content="content" :rowId="rowId" @fetchTableList="fetchTableList">
            <div style="text-align: center;">
                <template v-if="auditStatus === '1'">
                    <el-button type="primary" @click="confirmSubmit()">通 过</el-button>
                    <el-button type="danger" @click="toggleRejectDialog(true, rowId)">驳 回</el-button>
                </template>
                <el-button v-else @click="toggleDialog()">确 定</el-button>
            </div>
        </AvoidFoodDialog>
        <!-- 驳回弹窗 -->
        <RejectDialog :isOpen.sync="isShowRejectDialog" :rowId="rowId" :closeDialog="toggleDialog"
            :closeRejectDialog="toggleRejectDialog" @fetchTableList="fetchTableList" />
        <!-- 批量通过弹窗 -->
        <BatchPassDialog :count="multipleList.length" :isOpen.sync="isShowBatchPassDialog" :closeBatchPass="toggleBatchPassDialog" @batchPass="batchPass"/>
    </div>
</template>
<script>
import { post, get } from '@/api/http';
import tipsOne from '@/assets/dietaryNutrition/tipsOne.png';
import ShowReasonDialog from '../AuditCenter/ShowReasonDialog.vue';
import RecipeDialog from '../AuditCenter/RecipeDialog.vue';
import AuthoritativeGuideDialog from '../AuditCenter/AuthoritativeGuideDialog.vue';
import AvoidFoodDialog from '../AuditCenter/AvoidFoodDialog.vue'
import RejectDialog from './RejectDialog.vue';
import BatchPassDialog from './BatchPassDialog.vue';
export default {
    name: "ReviewManagement",
    components: { ShowReasonDialog, RecipeDialog, RejectDialog, AuthoritativeGuideDialog, AvoidFoodDialog, BatchPassDialog },
    created() {
        this.fetchTableList();
        this.getManageDoctorsList();
    },
    data() {
        return {
            form: {
                auditStatus: '',
                auditResult: '',
            },
            pageNum: 1,
            pageSize: 10,
            total: 0,
            activeKey: "0", // tapkey
            doctorNameList: [], // 医生列表
            table: [], // 表格数据
            auditResultList: [ // 审核结果列表
                { dictKey: '0', dictValue: '通过' },
                { dictKey: '1', dictValue: '驳回' },
            ],
            auditResultMap: {
                '0': '通过',
                '1': '驳回'
            },
            auditStatusList: [ // 审核状态列表
                { dictKey: '0', dictValue: '已审核' },
                { dictKey: '1', dictValue: '待审核' },
            ],
            auditStatusMap: {
                '0': '已审核',
                '1': '待审核'
            },
            doctorList: [], // 医生列表
            tipsOne,
            isShowDialog: false, // 展示错误原因弹窗
            reasonTxt: '', // 错误原因
            isShowRecipeDialog: false, // 展示食谱详情弹窗
            isShowAuthoritativeGuideDialog: false, // 展示权威指南详情弹窗
            isShowAvoidFoodDialog: false, // 展示过敏源详情弹窗
            isShowBatchPassDialog: false, // 展示批量通过提醒弹窗
            content: '', // 弹窗内容
            operType: '', // 操作类别 check - 查看详情 edit - 重新提交
            rowId: '', // 行id
            isShowRejectDialog: false, // 展示驳回弹窗
            auditStatus: '', // 审核状态
            multipleList: [], // 批量选择列表
            operId: '', // 操作人Id
        }
    },
    watch: {
        activeKey() {
            this.pageNum = 1;
            this.fetchTableList();
        }
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
        handleCurrentChange(pageNum) {
            this.pageNum = pageNum;
            this.fetchTableList();
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.fetchTableList();
        },
        // 查询
        queryList() {
            this.pageNum = 1;
            this.fetchTableList();
        },
        // 查询表格列表
        async fetchTableList() {
            try {
                const params = {
                    module: this.activeKey,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    userId: this.operId || '',
                    ...this.form
                }
                const result = await post('diet/audit/pageAuditList', params);
                const {
                    data: { total = 0, list = [], pageNum = 1, pageSize = 10 } = {},
                } = result;
                this.table = list;
                this.total = total;
                this.pageNum = pageNum;
                this.pageSize = pageSize;
            } catch (error) {
                console.log(error);
            }
        },
        // 展示驳回原因
        openReasonDialog(reasonTxt = '') {
            this.reasonTxt = reasonTxt;
            this.toggleReasonDialog(true);
        },
        // 切换对话框显示状态
        toggleReasonDialog(isFlag = false) {
            this.isShowDialog = isFlag;
        },
        toggleDialog(flag = false, content = '', operType = '', rowId = '', auditStatus = '') {
            this.content = content;
            this.operType = operType;
            this.rowId = rowId;
            this.auditStatus = auditStatus;
            switch (this.activeKey) {
                case '0':
                    this.isShowRecipeDialog = flag;
                    break;
                case '1':
                    this.isShowAuthoritativeGuideDialog = flag;
                    break;
                case '2':
                    this.isShowAvoidFoodDialog = flag;
                    break;
            }
        },
        // 切换驳回弹窗
        toggleRejectDialog(flag = false, rowId = this.rowId) {
            this.isShowRejectDialog = flag;
            this.rowId = rowId;
        },
        // 切换批量审批弹窗
        toggleBatchPassDialog(flag = false) {
            this.isShowBatchPassDialog = flag;
        },  
        // 通过审批
        async confirmSubmit(rowId = '') {
            try {
                const params = {
                    id: rowId || this.rowId,
                }
                const result = await post("/diet/audit/pass", params);
                const { code } = result;
                if (code === "SUCCESS") {
                    this.$message.success("提交成功");
                    this.toggleDialog(false);
                    this.fetchTableList();
                } else {
                    this.$message.error("提交失败，请重试！");
                }
            } catch (error) {
                console.log(error);
            }
        },
        // 判断是否可选
        isSelectAble(row) {
            return row.auditStatus === '1'
        },
        // 切换表格选项
        handleSelectionChange(val) {
            this.multipleList = val;
        },
        // 批量通过
        async batchPass() {
            try {
                const params = {
                    ids: this.multipleList.map(item => item.id),
                }
                const result = await post("/diet/audit/batchPass", params);
                const { code } = result;
                if (code === "SUCCESS") {
                    this.$message.success("提交成功");
                    this.fetchTableList();
                } else {
                    this.$message.error("提交失败，请重试！");
                }
            } catch (error) {
                console.log(error);
            }
        },
        // 重置
        reSet() {
            this.form = {
                auditStatus: '',
                auditResult: ''
            }
            this.operId = '';
            this.fetchTableList();
        },
        // 获取操作人列表
        async getManageDoctorsList() {
            try {
                const res = await get("/diet/audit/operatePerson");
                const { data = [] } = res;
                this.doctorList = data.map(item => ({dictKey: item.id, dictValue: item.name }));
            } catch (e) {
                console.error('获取操作人字典失败', e);
            }
        },
    }
}

</script>
<style scoped lang="scss">
.container {
    height: calc(100vh - 100px);
    display: flex;
    flex-direction: column;

    .list {
        flex: 1;

        .add-button-class {
            width: 100px;
        }
    }
}

.buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.tipsContainer {
    display: flex;
    justify-content: center;
    gap: 1px;
}
</style>